import { Component, Input, OnInit, inject } from '@angular/core';
import { ReviewLoanRequestComponent } from 'src/app/LoanRequest/review-loan-request/review-loan-request.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { CompanyAccess } from 'src/model/companyAccess.model';
import { LoanRequest } from 'src/model/loanRequest.model';
import { LoanGroupRequest } from 'src/model/sharedLoan.model';

@Component({
    selector: 'app-shared-loan-request-card',
    templateUrl: './shared-loan-request-card.component.html',
    styleUrls: ['./shared-loan-request-card.component.scss'],
    standalone: false
})
export class SharedLoanRequestCardComponent implements OnInit {
  private sharedService = inject(SharedService);

  @Input() loanGroupRequest: LoanGroupRequest;
  @Input() allAdminAccess: Record<string, CompanyAccess[]>;
  @Input() disallowProcess = false;
  @Input() clashedTickets: LoanRequest[];

  ngOnInit(): void {
  }

  openReviewLoanRequestModal() {
    const modalRef = this.sharedService.openModal(ReviewLoanRequestComponent, 'largeModal');
    modalRef.componentInstance.requestList = this.loanGroupRequest.requestList;
    modalRef.componentInstance.loanGroupId = this.loanGroupRequest.loanGroup;
    modalRef.componentInstance.disallowProcess = this.disallowProcess;
    modalRef.componentInstance.clashedTickets = this.clashedTickets;
  }

}
